<div class="offer-summary-widget">
  <span *ngIf="largeLoanProgramOffered"
        class="product-label">{{data.productLabel}}</span>
  <h3 [class.large-loan-title]="data.isLargeLoanProgram">
    {{data.productName}}
  </h3>
  <mat-card appearance="raised"
            class="offer-summary mat-elevation-z4"
            [ngClass]="{
    'loc-card':  data.offerType === offerType.LOC,
    'term-card':  data.offerType === offerType.Term,
    'law-card': data.offerType === offerType.Law,
    'large-loan-card': data.isLargeLoanProgram
    }"
            (click)="onClickDisplayAllOffers(data.offerType)">
    <mat-card-content fxLayout="row"
                      fxLayoutAlign="space-between center"
                      fxLayoutGap="12px">
      <div style="position: relative; z-index:999;"
           fxLayoutAlign="center center"
           fxFlex="7">
        <mat-icon *ngIf="data.offerType === offerType.LOC && !data.isLargeLoanProgram"
                  class="mat-white">data_saver_off</mat-icon>
        <mat-icon *ngIf="data.isLargeLoanProgram"
                  class="mat-white">workspace_premium</mat-icon>
        <mat-icon *ngIf="data.offerType === offerType.Term"
                  class="mat-white">assessment</mat-icon>
        <mat-icon *ngIf="data.offerType === offerType.Law"
                  class="mat-white">work</mat-icon>
      </div>
      <div fxLayout="column"
           fxLayoutAlign="space-between left"
           fxFlex="80">
        <span class="offer-value">{{data.amount | currency:'$'}}</span>
        <span class="offer-title">{{data.amountTitle}}</span>
        <span class="offer-value">{{data.repaymentTermLabel}}</span>
        <span class="offer-title">Repayment term</span>
        <div>
          <button mat-button
                  color="primary"
                  (click)="onClickDisplayAllOffers(data.offerType)">SEE ALL OFFERS</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <p *ngIf="data.isLargeLoanProgram"
     class="bank-integration-notice">
    {{bankIntegrationNotice}}
  </p>
</div>
